import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ColumnMode, DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {Contact} from '../../../entities';
import {JhiLanguageService} from 'ng-jhipster';
import {DeviceRefund} from '../../../entities/device-refund.model';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styles: []
})
export class EmployeeComponent implements OnInit {

  @ViewChild('employeeTable') employeeTable: DatatableComponent;
  sortingEmployees = {prop: 'lastname', dir: 'asc'};

  private modalRef: any = null;
  loadingIndicator = true;
  allEmployeeContacts: Contact[];
  employeeContacts: Contact[];
  tempEmployeeContacts = [];
  searchInput = '';

  branchFilter: {
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  functionFilter: {
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  appPermissionFilter: {
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  deviceRefunds: Array<DeviceRefund>;

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    private jhiLanguageService: JhiLanguageService,
    public router: Router,
  ) {
    this.jhiLanguageService.setLocations(['employee']);
    this.getDeviceRefunds().then(() => {
      this.getEmployees();
    });
  }

  ngOnInit() {
    this.branchFilter = {
      label: 'Filiale',
      options: [
        {
          value: 'all',
          label: 'alle Filialen'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Filialen'
      }
    };
    this.functionFilter = {
      label: 'Funktion',
      options: [
        {
          value: 'all',
          label: 'alle Funktionen'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Funktionen'
      }
    };
    this.appPermissionFilter = {
      label: 'App Berechtigung',
      options: [
        {
          value: 'all',
          label: 'alle'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle'
      }
    };
  }

  setDataTableColumnModeToForce() {
    if (this.employeeTable) {
      this.employeeTable.columnMode = ColumnMode.force;
    } else {
      setTimeout(() => {
        this.setDataTableColumnModeToForce();
      }, 100);
    }
  }

  getEmployees() {
    this.apiService.find<Contact>(Contact, 'employees/').subscribe(
      employeeContacts => {
        employeeContacts = employeeContacts
          .map(employeeContact => ({
            ...employeeContact,
            deviceRefundActive: (employeeContact.user) ? this.deviceRefundActive(employeeContact.user.id) : null
          }));
        this.employeeContacts = employeeContacts.filter(employee => employee.employeeActive !== 'False');
        this.allEmployeeContacts = employeeContacts.filter(employee => employee.employeeActive !== 'False');
        this.tempEmployeeContacts = [...this.employeeContacts];
        [...Array.from(new Set(this.employeeContacts.map(contact => contact.branchString)))]
          .sort()
          .forEach(branchString => {
            if (branchString && branchString !== '') {
              this.branchFilter.options.push({
                value: branchString,
                label: branchString
              });
            }
          });

        this.functionFilter.options.push(
          {
            value: 'Verwaltung',
            label: 'Verwaltung'
          }
        );

        this.functionFilter.options.push(
          {
            value: 'Marktmeister',
            label: 'Marktleitung'
          }
        );

        this.appPermissionFilter.options.push(
          {
            value: 'vorhanden (Live-System)',
            label: 'vorhanden (Live-System)'
          },
          {
            value: 'vorhanden (Schulungssystem)',
            label: 'vorhanden (Schulungssystem)'
          },
          {
            value: 'nicht vorhanden',
            label: 'nicht vorhanden'
          }
        );

        this.loadingIndicator = false;
        this.setDataTableColumnModeToForce();
      }, error => console.log('Error loading market-masters', error)
    );
  }

  getDeviceRefunds() {
    return new Promise(resolve => {
      this.apiService.find<DeviceRefund>(DeviceRefund, 'device-refunds').subscribe((deviceRefunds: Array<DeviceRefund>) => {
        this.deviceRefunds = deviceRefunds;
        resolve();
      });
    });
  }

  deviceRefundActive(userId): boolean {
    let result = true;
    const userDeviceRefunds = this.deviceRefunds.filter(deviceRefund => deviceRefund.user && deviceRefund.user.id === userId)
      .sort((a, b) => {
        const aValidDate = new Date(a.validFrom).getTime();
        const bValidDate = new Date(b.validFrom).getTime();
        if (aValidDate > bValidDate) {
          return -1;
        } else if (aValidDate < bValidDate) {
          return 1;
        } else if (aValidDate === bValidDate) {
          if (a.id > b.id) {
            return -1;
          } else if (a.id < b.id) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    if (userDeviceRefunds.length > 0
      && userDeviceRefunds[0].marketdateRefund === 0 && userDeviceRefunds[0].refundPerMerchant === 0) {
      result = false;
    }
    return result;
  }

  openModal(modal: any, options: NgbModalOptions = {}) {
    this.modalRef = this.modalService.open(modal, options);
  }

  onSelect(event) {
    this.router.navigate(['/employee/', event.selected[0].id]);
  }

  filterEmployees() {

    this.employeeContacts = this.allEmployeeContacts.filter(contact => {
      return ((this.branchFilter.selected.value !== 'all')
          ? contact.branchString === this.branchFilter.selected.value : true)
        && ((this.functionFilter.selected.value !== 'all')
          ? contact.category.search(this.functionFilter.selected.value) !== -1 : true)
        && ((this.appPermissionFilter.selected.value !== 'all'
          ? (this.appPermissionFilter.selected.value === 'vorhanden (Live-System)'
            || this.appPermissionFilter.selected.value === 'vorhanden (Schulungssystem)')
            ? (contact.user && contact.user.activated
              && (this.appPermissionFilter.selected.value === 'vorhanden (Live-System)'
                ? !contact.user.training : contact.user.training))
            : !(contact.user && contact.user.activated)
          : true));
    });

    this.tempEmployeeContacts = [...this.employeeContacts];

    if (this.searchInput !== '') {
      this.updateSearch(null);
    }
  }

  changeFilter(filter, filterOption) {
    filter.selected = filterOption;
    this.filterEmployees();
  }

  updateSearch(event) {
    const val = this.searchInput.toLowerCase();

    this.employeeContacts = this.tempEmployeeContacts.filter(function (employeeContact) {
      return employeeContact.firstname.toLowerCase().indexOf(val) !== -1 ||
        employeeContact.lastname.toLowerCase().indexOf(val) !== -1 ||
        ((employeeContact.merchantNumber) ? employeeContact.merchantNumber.indexOf(val) !== -1 : false) ||
        ((employeeContact.street) ? employeeContact.street.indexOf(val) !== -1 : false) ||
        ((employeeContact.zipcode) ? employeeContact.zipcode.indexOf(val) !== -1 : false) ||
        ((employeeContact.city) ? employeeContact.city.toLowerCase().indexOf(val) !== -1 : false) ||
        ((employeeContact.phone) ? employeeContact.phone.indexOf(val) !== -1 : false) ||
        ((employeeContact.mobile) ? employeeContact.mobile.indexOf(val) !== -1 : false) ||
        ((employeeContact.email) ? employeeContact.email.indexOf(val) !== -1 : false) ||
        !val;
    });
    this.employeeTable.offset = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/employee/components/employee/employee.component.ts